'use strict';

import errorNotice from './../error';
import dataHandler from './../data-handler';
import newPerDayChart from './new-per-day';
import totalPerRegion from './total-per-region';
import regionsPerDay from './regions-per-day';

const regionCharts = (function(){

    function init(data) {
        if (typeof data.confirmed !== 'undefined' && typeof data.confirmed.areas !== 'undefined') {
            // Update region data
            dataHandler.updateRegions(data);

            // Init charts
            newPerDayChart.init(data);
            totalPerRegion.init(data.confirmed);
            regionsPerDay.init(data.confirmed);
        } else {
            const error = 'Ongelma THL rajapinnassa, dataa sairaanhoitopiireistä ei saatavilla.';
            errorNotice.showDataError(error, '.shp-data-area');
        }
    }

    function reload(data, page, dataReload) {
        const totalPerRegionChartModeInput = document.querySelector('input[name="area-total-chart-data"]:checked');
        const regionPerDayChartModeInput = document.querySelector('input[name="region-line-chart-data"]:checked');
        const reloadCharts = [];

        if (page.classList.contains('reload-rate')) {
            // Update region rates
            dataHandler.calclulateRegionIncidenceRates(data.confirmed);

            // If rate mode selected in total chart, update
            if (totalPerRegionChartModeInput.value === 'rate' && reloadCharts.indexOf('totalPerRegion') === -1) {
                reloadCharts.push('totalPerRegion');
            }
            // If rate mode selected in region line chart, update
            if (regionPerDayChartModeInput.value === 'rate' && reloadCharts.indexOf('regionsPerDay') === -1) {
                reloadCharts.push('regionsPerDay');
            }

            page.classList.remove('reload-rate');
        }

        if (page.classList.contains('reload-date')) {
            // Update region rates
            dataHandler.calclulateRegionIncidenceRates(data.confirmed);
            // Calculate first day counts for new date
            dataHandler.calculateRegionFirstDayCounts(data.confirmed);

            if (reloadCharts.indexOf('newPerDay') === -1) {
                reloadCharts.push('newPerDay');
            }

            // If date mode selected in total chart, update
            if (regionPerDayChartModeInput.value === 'date' && reloadCharts.indexOf('totalPerRegion') === -1) {
                reloadCharts.push('totalPerRegion');
            }
            if (reloadCharts.indexOf('regionsPerDay') === -1) {
                reloadCharts.push('regionsPerDay');
            }
            page.classList.remove('reload-date');
        }

        // Reload charts
        for (let chartType of reloadCharts) {
            if (chartType === 'newPerDay') {
                newPerDayChart.reload(data);
            }
            if (chartType === 'totalPerRegion') {
                totalPerRegion.reload(data.confirmed);
            }
            if (chartType === 'regionsPerDay') {
                regionsPerDay.reload(data.confirmed);
            }
        }

        page.classList.remove('reload');
    }

    return {
        init,
        reload,
    }
})();

export default regionCharts;
